import { Box } from '@mui/material';
import FullscreenImageSlider from '../home/home';
import { Notification } from '../newsAndNotification/notification';
import { News } from '../newsAndNotification/news';
import { Case } from '../cases/case';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { Services } from '../sevices/services';



export const Root = () => {
    return (
        <Box  sx={{ minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
            <FullscreenImageSlider />
            <Notification/>
            <News/>
            <Services/>
            <Case/>

            {/* <TableComponent
        rows={acRows}
        columns={acData}
        manageColumnStatus
        enableSort="true"
      /> */}
        
        </Box>
    )
}